// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"5fe52d25","632":"b528e11e"}[chunkId] + ".chunk.js";
};